// extracted by mini-css-extract-plugin
export default {"slide":"Slide_slide__riDIG","italics":"Slide_italics__g9RMF"};